/**
 * Base URL of the NestJS API (T35). Env-configurable via `VITE_API_URL` (see `.env.example`);
 * defaults to the local dev API (`apps/api` on :3000, versioned prefix `/api/v1`) so `npm run dev`
 * works out of the box against a locally running API with zero config. CORS for :5174 is already
 * allowed by the API's dev config (`CORS_ORIGINS`).
 */
export const API_BASE_URL =
  import.meta.env.VITE_API_URL ?? "http://localhost:3000/api/v1";
